import { renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c6dcb5ea"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ribbon-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  id: "svg-ribbons",
  width: "1920px",
  viewBox: "0 0 1920 496",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink"
}, [
  /*#__PURE__*/_createElementVNode("title", null, "Branding/Ribbon"),
  /*#__PURE__*/_createElementVNode("g", {
    id: "Branding/Ribbon",
    stroke: "none",
    "stroke-width": "1",
    fill: "none",
    "fill-rule": "evenodd"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M1920,0 L1918.78819,497 L0,497 L0,63.0033011 C229.366992,92.2694595 521.643473,119.626784 876.829444,144.208912 C1045.95986,154.598684 1200.79264,194.512647 1460.92941,200.950954 C1721.06618,207.389261 1904.58228,58.7359501 1918.78819,2.22503491 C1918.81001,2.13821663 1919.29119,1.65679391 1919.73877,0.950606054 C1919.84646,0.780724786 1919.93354,0.463854052 1920,0 Z",
      id: "Ribbon-White-Overlay",
      "fill-opacity": "0.25",
      fill: "#FFFFFF"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M1919.9513,497 L0,497 L0,151.148527 C229.353378,123.900723 521.612512,124.442347 876.7774,149.157484 C1045.89778,160.0475 1204.44581,199.51789 1460.83899,200.714293 C1717.23217,201.893897 1865.51829,105.188457 1915.60907,31.9032445 C1915.68168,31.7970091 1919.41302,24.8794448 1919.87054,24 C1919.96826,23.791825 1920.05899,228.911408 1919.9513,497 Z",
      id: "Ribbon-Effect-2",
      "fill-opacity": "0.25",
      fill: "#17181A"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M1920,37 L1919.94877,497 L0,497 L0,191.2755 C229.353076,135.437767 521.611825,123.371603 876.776247,149.022339 C1045.8964,160.212732 1204.74108,203.702341 1461.13392,205.293953 C1717.52676,206.858791 1889.67673,102.346064 1916.27841,47.5004724 C1917.54125,44.8968298 1919.43588,38.3899584 1920,37 Z",
      id: "Ribbon-Branding",
      fill: "#30BFBF"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M1919.87135,86 L1920,497 L0,497 L0,436.282997 C229.353076,215.764095 521.611825,127.507336 876.776247,154.924152 C1045.8964,166.938595 1204.27627,212.521114 1460.66911,215.013899 C1717.06195,217.465781 1876.25114,140.723933 1914.27977,94.3095045 C1914.31755,94.263837 1916.18141,91.4914197 1919.87135,86 Z",
      id: "Ribbon-Effect",
      "fill-opacity": "0.1",
      fill: "#17181A"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M1919.93482,130 L1920,497 L0,497 L0,438.218622 C217.939897,254.108482 509.18676,172.20708 873.740588,180.542743 C1036.25719,184.164937 1204.3084,226.399054 1460.70808,229.719009 C1717.10777,232.958226 1878.58064,178.739185 1916.61029,133.920813 C1918.71267,131.467766 1919.82085,130.16147 1919.93482,130 Z",
      id: "Ribbon-Foreground",
      fill: "#F2F4F7"
    })
  ])
], -1))
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "background-image-container",
      style: _normalizeStyle(_ctx.containerStyle)
    }, [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ], 4),
    _createElementVNode("div", {
      class: "svg-container",
      style: _normalizeStyle(_ctx.svgStyle)
    }, _hoisted_3, 4),
    _createElementVNode("div", {
      class: "bottom-overlap",
      style: _normalizeStyle(_ctx.overlapStyle)
    }, null, 4)
  ]))
}